module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAAAXNSR0IArs4c6QAAAGRJREFUKFNjZA3b/J8BD/jPwNDwZ5VvI0wJI0jD71W+jLj0gOSRNRGlgeE/w9X/jAyrQTYRpwFqPcgmghqQnQpyHooG9ABA9xuGBnyhBZKjXAOuOIE5jXIbSPbDIHISIbcjywMA5LFuK7QquOMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file.png
// module id = 104
// module chunks = 0